import React from 'react';

export default function EditMechinery() {
  return <div>EditMechinery</div>;
}
